import { render } from "./AiCreatedBadge.vue?vue&type=template&id=0953943a"
import script from "./AiCreatedBadge.vue?vue&type=script&lang=js"
export * from "./AiCreatedBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AiCreatedBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0953943a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0953943a', __exports__)) {
    api.reload('0953943a', __exports__)
  }
  
  module.hot.accept("./AiCreatedBadge.vue?vue&type=template&id=0953943a", () => {
    api.rerender('0953943a', render)
  })

}


export default __exports__